import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IGameStageWinnerSet, IGameWonArgs } from '@/components/game/_domain/models';
import BasePrizeComponent from '@/components/game/implementations/_base/_components/prize';
import JackpotComponent from '@/components/game/implementations/_default/_components/jackpot';
import { PotionRecipeItem } from '@/components/game/implementations/uk/potion/_domain/models';

@Component({
  name: 'PotionPrizeComponent',
  components: {
    jackpot: JackpotComponent
  }
})
export default class PotionPrizeComponent extends BasePrizeComponent {
  private mounted() {
    Vue.nextTick(() => {
      this.gameController
          .onGameStateChanged(this.handleGameStateChanged)
          .onGameRepresentationChanged(this.handleGameRepresentationChanged)
          .onNextGameRepresentationChanged(this.handleNextGameRepresentationChanged)
          .onGameWon(this.handleGameWon);
    });
  }

  protected handleGameWon(eventArgs: IGameWonArgs) {
    this.updatePrizeWinners(eventArgs.gameWinnerInfo);
  }

  private updatePrizeWinners(gameWinnerInfo: IGameStageWinnerSet[]) {
    gameWinnerInfo.forEach((winnerSet) => {
      const usernameString = this.getWinnerUsernameList(winnerSet);
      const winnersElement = this.$el.querySelectorAll(`.prize-winners span[data-stage="${winnerSet.prizeName}"]`);
      if (winnersElement) {
        Array.from(winnersElement).forEach((element: Element) => {
          element.innerHTML = usernameString;
        });
      }
    }, this);
  }

  protected getWinnerUsernameList(winnerSet: IGameStageWinnerSet): string {
    const ticketBooks = winnerSet.ticketBooks || [];
    const winners = ticketBooks[0].winners || [];
    let firstIteration = true;
    let usernameString = '';
    winners.forEach((winner) => {
      usernameString += (firstIteration ? '' : ', ') + winner.username;
      firstIteration = false;
    });
    return usernameString;
  }

  private getPathToCallImage(recipeItem: PotionRecipeItem): string {
    const rootPath = '/static/games/potion/skins/default/recipes';
    if (recipeItem.promoType) {
      return `${rootPath}/${recipeItem.promoType}/${recipeItem.symbol}.png`;
    }
    return `${rootPath}/${recipeItem.symbol}.png`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/potion/_components/prize/prize.component.ts